// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-card__subtitle[data-v-419f0568]\n{\n    padding: 2px;\n    margin-top: 0px;\n}\n", ""]);
// Exports
module.exports = exports;
